import { useTheme } from 'styled-components'

import { Flex, Margin } from '@/@bothrs-ui/web/components/layout'
import { BigNumber } from './AddContactsListItem.styled'

import type { ReactNode } from 'react'

export const ListItem = ({ children, index }: { children: ReactNode; index: number }) => {
  const theme = useTheme()

  return (
    <Margin mb={theme.UI.Spacing.Space3}>
      <Flex alignItems={'center'} gap={theme.UI.Spacing.Space2}>
        <BigNumber>{index}</BigNumber>
        {children}
      </Flex>
    </Margin>
  )
}
